<span class="status-badge" [attr.data-tone]="tone()">{{ label() }}</span>
